module.exports = __webpack_public_path__ + "img/img0.8e167436.jpg";